module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "left-box resizable",
    style: ({
      width: width + 'px'
    }),
    attrs: {
      "id": "workspace"
    },
    on: {
      "click": function($event) {
        $emit('click')
      }
    }
  }, [_h('resizer', {
    attrs: {
      "type": "vertical"
    },
    on: {
      "resizer:begin": onResizeBegin,
      "resizer:resize": onResize
    }
  }), " ", _h('div', {
    staticClass: "box-header"
  }, [_m(0), " ", _h('span', {
    staticClass: "box-caret glyphicon glyphicon-menu-left",
    on: {
      "click": function($event) {
        $emit('workspace:close')
      }
    }
  })]), " ", _h('div', {
    staticClass: "box-body"
  }, [_h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!files.length),
      expression: "!files.length"
    }],
    staticClass: "placeholder"
  }, ["Nothing to show"]), " ", _h('ul', {
    staticClass: "list",
    attrs: {
      "id": "file-list"
    }
  }, [_l((files), function(file) {
    return _h('li', {
      class: {
        active: file == selectedFile
      },
      attrs: {
        "data-bind": "attr: {id: attrId}, css: {active: isActive},\n                      event: {contextmenu: $parents[0].setActive.bind($data)}"
      },
      on: {
        "click": function($event) {
          selectedFile = file
        },
        "dblclick": function($event) {
          openFileInEditor(file)
        }
      }
    }, [_m(1, true), " ", _h('span', [_s(file.fileName)])])
  })])])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "box-title"
  }, ["Workspace"])
}},function (){with(this) {
  return _h('span', {
    staticClass: "glyphicon glyphicon-file"
  })
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-bb1c7de2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Workspace.vue
 ** module id = 136
 ** module chunks = 2
 **/